export default {
  setSliders(state, data) {
    state.sliders = data;
  },

  setBlogs(state, data) {
    state.blogs = data;
  },

  setMedias(state, data) {
    state.medias = data;
  },

  setSounds(state, data) {
    state.sounds = data;
  },

  setPhotos(state, data) {
    state.photos = data;
  },

  setBooks(state, data) {
    state.books = data;
  },
};
